import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { NodeViewWrapper } from "@tiptap/react";
import styled, { css } from "styled-components";
import { themeGet } from "sprout-ui-theme";
import imageCache from "sprout-lib/dist/image-cache";
const Img = styled("img")`
  ${({ $selected  })=>$selected && css`
      box-shadow: 0 0 0 3px ${themeGet("colors.blue.500")};
    `}
`;
const Image = (props)=>{
    const { selected , node , editor , getPos  } = props;
    const { alt , src  } = node.attrs;
    const handleImageClick = useCallback(()=>{
        editor.commands.setNodeSelection(getPos());
    }, [
        editor.commands,
        getPos
    ]);
    return /*#__PURE__*/ _jsx(NodeViewWrapper, {
        as: "figure",
        children: /*#__PURE__*/ _jsx(Img, {
            $selected: selected,
            onClick: editor.isEditable ? handleImageClick : undefined,
            alt: alt,
            src: imageCache(src, {
                auto: "format"
            }),
            "data-drag-handle": true,
            contentEditable: "false"
        })
    });
};
export default Image;
